import React, { useState } from 'react';
import { Constrain, Stack, Text, Button } from '@moda/om';
import { tc } from '../../lib/trackingContext';
import { ModaNetworkRequestModal } from './ModaNetworkRequestModal';

import './ModaNetwork.scss';

export const ModaNetwork: React.FC = () => {
  type ModaNetworkListEvent = 'Moda Network Show Form Clicked';

  const [showRequestModal, setShowRequestModal] = useState(false);
  const handleClick = (text: ModaNetworkListEvent, label: string, location: string) => {
    setShowRequestModal(true);
    tc.track(text, {
      addToTrackingEvent: {
        label: label,
        location: location
      }
    });
  };
  return (
    <>
      <div className="ModaNetwork">
        <Stack space={5} className="ModaNetwork__top-section">
          <Stack space={0}>
            <div className="ModaNetwork__section-title">MODA Network</div>
            <Text color="ink" treatment="body1" className="ModaNetwork__service-text">
              The INVITATION-ONLY Network for Stylists & Costume Designers.
              <br />A 360˚ wardrobing experience personalized for your business,
              <br /> offering consignment, one-of-a-kind industry opportunities, an
              <br /> unprecedented access to luxury brands and designers
            </Text>
            <Text treatment="h4" className="ModaNetwork__benefits-text">
              What are the benefits of joining?
            </Text>
            <ul className="ModaNetwork__list-text">
              <li>We offer competitive commissions or a private discount</li>
              <li> Dedicated Point-of-Contact for all of your shopping & styling needs</li>
              <li>Access to private sourcing and one of kind pieces</li>
              <li> Exclusive invitations to insider events</li>
              <li>Access to consignment (US only)</li>
            </ul>
            <div className="ModaNetwork__button">
              <Button
                className="ModaNetwork__button-main"
                onClick={() =>
                  handleClick('Moda Network Show Form Clicked', 'INQUIRE NOW', 'INQUIRE NOW button')
                }
              >
                INQUIRE NOW
              </Button>
            </div>
          </Stack>
        </Stack>
        <Constrain className="ModaNetwork__constrain">
          <Stack space={5} className="ModaNetwork__faq-section">
            <div className="ModaNetwork__section-title">FAQs</div>
            <Stack space={4}>
              <Stack space={1}>
                <Text color="ink" family="serif" treatment="h5">
                  How can I sign up to become an affiliate stylist on Moda Network?
                </Text>
                <Text color="cement" treatment="body1">
                  Moda Network is an invitation-only program. If you are interested in joining,
                  please fill out our inquiry form. Our team will review your information and reach
                  out if you qualify for the program.
                </Text>
              </Stack>
              <Stack space={1}>
                <Text color="ink" family="serif" treatment="h5">
                  What is Moda Network and who can join?
                </Text>
                <Text color="cement" treatment="body1">
                  Moda Network is a premier program tailored for stylists and costume designers. We
                  provide a full-service wardrobing experience that includes consignment options,
                  private sourcing, and access to top-tier luxury brands and designers. Our services
                  are designed to streamline your workflow, making shopping and styling for clients
                  or events more efficient and enjoyable.
                </Text>
              </Stack>

              <Stack space={1}>
                <Text color="ink" family="serif" treatment="h5">
                  What are the benefits of joining Moda Network?
                </Text>
                <Text color="cement" treatment="body1">
                  As a member of Moda Network, you will receive weekly curated edits, opportunity
                  for competitive commission or private discount, a dedicated point-of-contact for
                  all your shopping and styling needs, access to one-of-a-kind fine jewelry
                  selections and rare vintage sourcing, exclusive invitations to insider events, and
                  access to consignment services within the United States.
                </Text>
              </Stack>
              <Stack space={1}>
                <Text color="ink" family="serif" treatment="h5">
                  How does consignment work with Moda Network?
                </Text>
                <Text color="cement" treatment="body1">
                  Consignment with Moda Network allows you to curate a selection of beautiful pieces
                  for client fittings, premieres, and special events without visiting a store.
                  Consignments are currently accessible to US shipping addresses only. Please note
                  that consignment privileges are granted at the discretion of the Moda Network
                  team.
                </Text>
              </Stack>
              <Stack space={1}>
                <Text color="ink" family="serif" treatment="h5">
                  Can I place my own orders, or do I need your help each time?
                </Text>
                <Text color="cement" treatment="body1">
                  Absolutely, you can place your own orders! Just be sure to log into your Affiliate
                  account when making a purchase, and you'll automatically earn your commission.
                  Enjoy the convenience and all the perks!
                </Text>
              </Stack>
            </Stack>
          </Stack>
        </Constrain>
        <div className="ModaNetwork__private">
          <Stack space={1} className="ModaNetwork__private-left">
            <img
              className="ModaNetwork__private-image"
              src="/dist/public/stylist/mn.png"
              alt="Moda Network"
            />
          </Stack>
          <Stack space={1} className="ModaNetwork__private-right">
            <Text treatment="h3" className="ModaNetwork__private-title">
              Looking for a stylist?
            </Text>
            <Text treatment="body1">MODA PRIVATE</Text>
            <img className="ModaNetwork__private-logo" src="/dist/public/stylist/MO.png" alt="MO" />
            <Text treatment="body1" className="ModaNetwork__private-text">
              Years of industry experience and unique points of view on fashion allow our team of
              experts to elevate your shopping experience.
            </Text>
            <a className="Button ModaNetwork__button-main" href="/moda-private">
              LEARN MORE
            </a>
          </Stack>
        </div>
      </div>
      <ModaNetworkRequestModal show={showRequestModal} onClose={() => setShowRequestModal(false)} />
    </>
  );
};
